// Snyk security scan required for new/modified code. Ensure to run Snyk after changes.
interface PKSOFTUrlsType {
  CUSTOMER: {
    REGISTER: string;
    REGISTER_OTP: string;
    REGISTER_V2: string;
    REGISTER_OTP_V2: string;
    LOGIN: string;
    PRODUCT: string;
    CATEGORY: string;
    CATEGORY_DETAILS:string;
    LOAD_TAGS: string;
    DETAILS: string;
    COUNT: string;
    CHECKLIST: string;
    BAG: string;
    WISHLIST: string;
    CART: string;
    BRAND: string;
    SELLER: string;
    FORGET_PASSWORD: string;
    FORGET_PASSWORD_OTP: string;
    SEARCH: string;
    RENDER: string;
    CATEGORY_BRAND: string;
    FILTER: string;
    ALLPRODUCTS: string;
  };
  GUEST: {
    GUEST_REGISTER: string;
    GUEST_OTP: string;
    GUEST_ORDER: string;
  };
  ORDER: {
    PROCEED: string;
    SUCCESS: string;
    USER_ORDER: string;
  };
  ADDRESS: {    
    CREATE: string;
    UPDATE: string;
    DELETE: string;
    GET: string;
    SET_DEFAULT: string;
  };
  CANCEL: {
    ORDER: string;
  };
  SELLER: {
    LOAD: string;
  };
  BRAND: {
    LOAD: string;
  };

}

const PKSOFT_URLS: PKSOFTUrlsType = {
  SELLER: {
    LOAD: "api/pk/Customer/load/details", // TEMP endpoint for seller store
  },
  BRAND: {
    LOAD: "api/pk/Customer/load/details", // TEMP endpoint for brand store
  },
  CUSTOMER: {
    // v1 register/verify is still used by RegisterModal (checkout).
    REGISTER: "api/pk/Customer/register",
    REGISTER_OTP: "api/pk/Customer/verify-otp",
    // v2 adds a user-chosen password; used by the register modal.
    REGISTER_V2: "api/pk/Customer/v2/register",
    REGISTER_OTP_V2: "api/pk/Customer/v2/verify-otp",
    LOGIN: "api/pk/Customer/auth",
    PRODUCT: "api/pk/Customer/product",

    CATEGORY: "api/pk/Customer/load/category",
    CATEGORY_DETAILS:"api/pk/Customer/load/details",
    DETAILS: "api/pk/Customer/load/details",
    LOAD_TAGS: "api/pk/Customer/loadTagWiseProducts",
    
    BRAND: "api/pk/Customer/brand",
    SELLER: "api/pk/Customer/seller",
    CATEGORY_BRAND: "api/pk/Customer/brands",

    COUNT: "api/pk/Customer/Count", //{count}
    CHECKLIST: "api/pk/Customer/CheckList", //{wishlist-list}
    BAG: "api/pk/Customer/Bag", //{get cart & wishlist}

    WISHLIST: "api/pk/Customer/wishlist", //{add/remove from wishlist}
    CART: "api/pk/Customer/Cart", //{add/remove from cart}
    FORGET_PASSWORD: "api/pk/Customer/forget-password",
    FORGET_PASSWORD_OTP: "api/pk/Customer/verify-forget-password-otp",
    SEARCH: "api/pk/Customer/search",
    RENDER: "api/pk/Customer/render",
    FILTER: "api/pk/Customer/filters",
    ALLPRODUCTS: "api/pk/Customer/filterProducts",
  },
  GUEST: {
    GUEST_REGISTER: "api/pk/Customer/guest/auth",
    GUEST_OTP: "api/pk/Customer/verify-guest",
    GUEST_ORDER: "api/pk/Order/GuestOrders",
  },
  ORDER: {
    PROCEED: "api/pk/Order/proceed",
    SUCCESS: "api/pk/Order/success",
    USER_ORDER: "api/pk/User/Orders",
  },
  ADDRESS: {
    CREATE: "api/pk/Customer/Address/Create",
    UPDATE: "api/pk/Customer/Address/Update",
    DELETE: "api/pk/Customer/Address/Delete",
    GET: "api/pk/Customer/Address/List",
    SET_DEFAULT: "api/pk/Customer/Address/Primary",
  },
  CANCEL: {
    ORDER: "api/pk/Order/cancel",
  },
};
export default PKSOFT_URLS;
